import React from 'react';
import { Container, makeStyles, Button, Divider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Helmet } from 'react-helmet';

import { Trans } from 'react-i18next';
import { Text } from '../shared/components/Text';

import { Theme } from '../shared/theme/Theme';
import { Footer } from '../components/footer/Footer';
import { IntroFooter } from '../components/footer/IntroFooter';
import { Header } from '../components/header/Header';
import ResponsiveMenu from '../components/header/header-components/HamburgerMenu';
import { SwitchColor } from '../shared/components/SwitchColor';
import { Sections } from '../components/sections/Sections';

import '../shared/fonts/fonts.css';

const useStyle = makeStyles((theme) => ({
  container: {
    background: '#696A76',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  containerHome: {
    background: '#818293',
    height: '100vh',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    /* TEST */
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    color: 'white',
    border: 'none',
    borderRadius: '0',
    textDecoration: 'none !important',
    background: '#a6e110',
    fontSize: '8px',
    '&:hover': {
      color: 'white',
      border: 'none',
      background: '#a6e110',
    },
    '&:focus': {
      color: theme.palette.primary.main,
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.primary.main,
    },

  },

  cookie: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    zIndex: 999999,
    background: '#696a76',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '20px 30px',
    fontSize: '10px',
    '& > a ': {
      textDecoration: 'none !important',
      color: 'white !important',
    }
  }
}));

export default function IndexPage() {
  const windowGlobal = typeof window !== 'undefined' && window;
  const [cookie, setcookie] = React.useState('false');
  const styles = useStyle();

  React.useEffect(() => {
    if (!windowGlobal.localStorage.getItem('accepted-cookie')) {
      setcookie(() => {
        windowGlobal.localStorage.setItem('accepted-cookie', 'false');
        return windowGlobal.localStorage.getItem('accepted-cookie');
      });
    }
    if (windowGlobal.localStorage.getItem('accepted-cookie') === 'false') {
      setcookie(() => {
        windowGlobal.localStorage.setItem('accepted-cookie', 'false');
        return windowGlobal.localStorage.getItem('accepted-cookie');
      });
    }
  }, [cookie]);

  const onCookieHandle = () => {
    setcookie(() => {
      windowGlobal.localStorage.setItem('accepted-cookie', 'true');
      return windowGlobal.localStorage.getItem('accepted-cookie');
    });
  };
  // React.useLayoutEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = 'https://apis.google.com/js/api.js';
  //   script.async = true;
  //   document.body.appendChild(script);
  // }, []);

  return (
    <Theme>
      <Helmet>
        <meta charSet="utf-8" />
        <title>BG | Servizi Professionali</title>
      </Helmet>
      <CssBaseline />
      <div className={styles.container}>
        <div className={styles.containerHome}>
          <Header />
          <ResponsiveMenu />

          <SwitchColor />
          <IntroFooter />
        </div>
        <Container disableGutters fixed>
          <Sections />
        </Container>
      </div>
      {
        windowGlobal && (windowGlobal.localStorage.getItem('accepted-cookie') === 'false' || !windowGlobal.localStorage.getItem('accepted-cookie')) && (
        <div className={styles.cookie}>
          <a href="/privacy/" target="_blank">
            Privacy
          </a>
          <Divider width="20px" />
          <Button
            disableRipple
            disableFocusRipple
            className={styles.button}
            onClick={onCookieHandle}
          >
            <Text variant="h6">
              <Trans>Accetta</Trans>
            </Text>
          </Button>
          <Divider width="10px" />
          <Button
            disableRipple
            disableFocusRipple
            className={styles.button}
            onClick={onCookieHandle}
          >
            <Text variant="h6">
              <Trans>Rifiuta</Trans>
            </Text>
          </Button>

        </div>
        )
      }

      <Footer />
    </Theme>
  );
}
